import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import styles from './video.module.scss';

const Video = () => {
  const navigate = useNavigate();

  const onClickSkip = () => {
    navigate(`/devices`);
  };

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <video
          className={styles.video}
          src={'/img/0069_UA-2-2.mp4'}
          onEnded={() => onClickSkip()}
          autoPlay={true}
        />
        <button
          onClick={() => onClickSkip()}
          className={classNames(styles.btn, styles.primary, styles.button)}
        >
          Пропустити
          <span />
        </button>
      </div>
    </div>
  );
};

export { Video };
